import { motion } from "framer-motion";
import { Play, Eye } from "lucide-react";

const TIKTOK_URL = "https://www.tiktok.com/@schatten_psyche_";

export const AuthorSection = () => (
  <section id="author" className="relative py-20 sm:py-24 lg:py-36" data-testid="author-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
      <motion.div
        initial={{ opacity: 0, x: -40 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.9 }}
        className="lg:col-span-5"
      >
        <div className="relative max-w-sm mx-auto lg:mx-0">
          <div className="absolute -inset-6 bg-neon-magenta/8 blur-3xl rounded-full pointer-events-none" />
          <div className="relative aspect-[4/5] rounded-sm overflow-hidden ring-1 ring-white/15 bg-void-surface flex flex-col items-center justify-center gap-6">
            <img src="/logo.png" alt="Schattenpsyche Augen-Emblem" className="w-40 opacity-80" />
            <p className="font-typewriter uppercase tracking-[0.3em] text-slate-500 text-xs">
              Subjekt-Foto · geschwärzt
            </p>
            <span className="tape -top-2 left-10 rotate-[-6deg]" />
            <span className="tape -top-2 right-10 rotate-[5deg]" />
          </div>
          <span className="stamp absolute -bottom-4 right-2 bg-void text-xs">Geheim</span>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, x: 40 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.9, delay: 0.15 }}
        className="lg:col-span-7"
      >
        <p className="font-mono text-xs uppercase tracking-[0.35em] text-slate-400 mb-4">
          Der Autor
        </p>
        <h2 className="font-cinzel text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tight">
          Der Kopf hinter
          <br />
          dem Auge
        </h2>
        <p className="mt-6 text-base sm:text-lg leading-relaxed text-slate-400 max-w-xl">
          Bekannt auf TikTok als{" "}
          <span className="text-white font-semibold">@schatten_psyche_</span>:
          Profiler-Psychologie in kurzen, scharfen Videos und ein sehr praktisches Handbuch.
          Das Gesicht bleibt im Schatten, die Beobachtungen nicht.
        </p>

        <div className="mt-8 flex flex-wrap gap-3">
          {["BookTok-Creator", "Profiling & Psychologie", "Trilogie · Band 1 von 3"].map((chip) => (
            <span
              key={chip}
              className="px-4 py-2 rounded-full border border-white/10 bg-white/5 font-mono text-xs tracking-wider text-slate-300"
            >
              {chip}
            </span>
          ))}
        </div>

        <a
          href={TIKTOK_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="author-tiktok-link"
          className="mt-10 inline-flex items-center gap-4 glass rounded-2xl p-5 pr-8 group hover:border-white/40 transition-colors duration-300"
        >
          <span className="w-14 h-14 rounded-xl bg-white/10 border border-white/20 flex items-center justify-center">
            <Play className="w-5 h-5 text-white fill-current" />
          </span>
          <span>
            <span className="block font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">
              Aktuelle Signale auf
            </span>
            <span className="block font-typewriter text-xl text-white transition-colors">
              tiktok.com/@schatten_psyche_
            </span>
          </span>
          <Eye className="w-5 h-5 text-slate-600 group-hover:text-white transition-colors ml-2" />
        </a>
      </motion.div>
    </div>
  </section>
);
